//WagesReport.js

import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';
import Button from '@mui/material/Button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import Serverurl from './Apiurl';
import {
  Container,
  Paper,
  Box,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    { id: 'LabourDate', numeric: false, label: 'Date', disablePadding: true },
    { id: 'ProjectName', numeric: false, label: 'Project', disablePadding: true },
];

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, rowCount, dynamicColumns } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
                {dynamicColumns.map(col => (
                    <TableCell
                        key={col}
                        align="right"
                        padding="none"
                    >
                        {col}
                    </TableCell>
                ))}
                <TableCell
                    align="right"
                    padding="none"
                >
                    <b>Grand Total</b>
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    dynamicColumns: PropTypes.array.isRequired,
};

export default class WagesReport extends Component {
    constructor(props) {
        super(props);
        const currentDate = new Date();
        this.state = {
            redirect: false,
            pagename: '',
            fromDate: dayjs(currentDate).startOf('month'),
            toDate: dayjs(currentDate).endOf('month'),
            fromDate1: dayjs(currentDate).startOf('month').format('YYYY-MM-DD'),
            toDate1: dayjs(currentDate).endOf('month').format('YYYY-MM-DD'),
            projectId: '',
            projectName: '',
            filteredProjects: [],
            loadingProjects: false,
            projects: [],
            projectarray: [],
            projectarrauto: [],
            selectedProject: null,
            reportData: [],
            grandTotalAmount: 0,
            loading: false,
            error: '',
            totalHeads: 0,
            totalAmount: 0,
            page: 0,
            rowsPerPage: 50,
            order: 'desc',
            orderBy: 'LabourDate',
            dynamicColumns: [],
            openExportDialog: false,
        };
    }
	
	getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
apicall = () => {
 this.setState({ loading: true, error: '' });
        
    axios.get(Serverurl + 'ajaxlaborexpensesreport.php?action=getlabourreport' +
        '&from_date=' + this.state.fromDate1 +
        '&to_date=' + this.state.toDate1 +
        '&project_id=' + this.state.projectId +
        '&index=' + this.state.page +
        '&maxrecord=' + this.state.rowsPerPage +
        '&orderby=' + this.state.orderBy.split(' ')[0] +
        '&order=' + this.state.order)
    .then((resp) => {
        const data = Array.isArray(resp.data) ? resp.data : [];
        
        let grandTotalAmount = 0;
        data.forEach((item) => {
            grandTotalAmount += Number(item.GrandTotalAmount || 0);
        });

        let dynamicColumns = [];
        if (data.length > 0) {
            dynamicColumns = Object.keys(data[0]).filter(
                key => !['count', 'LabourDate', 'ProjectName', 'GrandTotalAmount'].includes(key)
            );
        }

        this.setState({
            reportData: data,
            grandTotalAmount,
            totaldata: data.length,
            totalRecords: parseInt(resp.data[0]?.count || data.length),
            dynamicColumns,
            loading: false
        });
    })
    .catch(() => {
        this.setState({
            loading: false,
            error: "Unable to fetch report data"
        });
    });
};

searchProject = (event, value) => {
    this.setState({
        projectName: value,
        projectId: '',
        loadingProjects: true
    });

    if (!value || value.trim() === '') {
        this.setState({
            filteredProjects: [],
            loadingProjects: false
        });
        return;
    }

    axios
        .get(Serverurl + "ajaxprojects.php?action=getallprojectautoextender&pj_projectname=" + value)
        .then((response) => {
            this.setState({
                filteredProjects: response.data || [],
                loadingProjects: false
            });
        })
        .catch(() => {
            this.setState({
                loadingProjects: false
            });
        });
};
    componentWillMount() {
        document.title = "VR Builders - Wages Report";
        
   	if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Wages Report";   
			 this.props.parentsCallback(
           strname
        );
       let search = window.location.href;
	let projectId = this.getParameterByName('projectid',search);	
 if (projectId!==null ) {
    this.setState(
      { projectId},
      () => {
      
        this.loadProjectById(projectId); 
      }
    );
  } else {
    this.apicall();
  }
    
    }
	
	loadProjectById = (projectId) => {
  axios
    .get(Serverurl + "ajaxprojects.php", {
      params: {
        action: "getall",
        pj_id: projectId
      }
    })
    .then((res) => {
		
      const data = res.data?.[0];

      if (data) {
        this.setState({
          selectedProject: {
            title: data.pj_projectname,
            pj_id: data.pj_id
          },projectName:data.pj_projectname,
		  projectId:data.pj_id,
        },()=>{this.apicall(); });
      }
    });
};
    selectProject = (event, value) => {
        this.setState({
            projectId: value ? value.pj_id : '',
            projectName: value ? value.pj_projectname : ''
        });
    };

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
handleSearch = () => {

    if (!this.state.projectId) {
        this.setState({
            error: 'Please Select Project'
        });
        return;
    }

    this.setState({
        error: '',
        page: 0
    }, () => {
        this.apicall(0, this.state.rowsPerPage);
    });
};

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({
            orderBy: property,
            order: isAsc ? 'desc' : 'asc',
            page: 0
        }, () => {
            this.apicall(0, this.state.rowsPerPage);
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => {
            this.apicall(newPage, this.state.rowsPerPage);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        }, () => {
            this.apicall(0, parseInt(event.target.value));
        });
    };

    formatDate = (dateString) => {
        if (!dateString) return '';
        return dayjs(dateString).format('DD-MM-YYYY');
    };

    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };

    handleDownloadPDF = () => {
        const { reportData, grandTotalAmount, dynamicColumns } = this.state;
        const doc = new jsPDF('l', 'mm', 'a4');
        
        doc.setFontSize(14);
        doc.text('Labor Report', 14, 15);

        const headers = [['Date', 'Project', ...dynamicColumns, 'Grand Total Amount']];
        const rows = reportData.map(item => [
            this.formatDate(item.LabourDate),
            item.ProjectName || '',
            ...dynamicColumns.map(col => item[col] || ''),
            Number(item.GrandTotalAmount || 0).toLocaleString('en-IN')
        ]);

        rows.push([
            '',
            'Grand Total',
            ...Array(dynamicColumns.length).fill(''),
            Number(grandTotalAmount).toLocaleString('en-IN')
        ]);

        doc.autoTable({
            head: headers,
            body: rows,
            startY: 25,
            theme: 'striped',
            styles: {
                fontSize: 8
            },
            headStyles: {
                fillColor: [25, 118, 210]
            }
        });

        doc.save('Wages_Report.pdf');
    };

    exportExcel = () => {
        const { reportData, dynamicColumns, grandTotalAmount } = this.state;
        if (!reportData.length) {
            alert('No data available');
            return;
        }

        const excelData = reportData.map(item => {
            const rowData = {
                Date: this.formatDate(item.LabourDate),
                Project: item.ProjectName,
            };
            
            dynamicColumns.forEach(col => {
                rowData[col] = item[col];
            });
            
            rowData['Grand Total Amount'] = Number(item.GrandTotalAmount || 0).toLocaleString('en-IN');
            return rowData;
        });

        const totalRow = {
            Date: '',
            Project: 'Grand Total',
        };
        dynamicColumns.forEach(col => {
            totalRow[col] = '';
        });
        totalRow['Grand Total Amount'] = Number(grandTotalAmount).toLocaleString('en-IN');
        excelData.push(totalRow);

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Labor Report');

        const buffer = XLSX.write(wb, {
            bookType: 'xlsx',
            type: 'array'
        });
        saveAs(
            new Blob([buffer], {
                type: 'application/octet-stream'
            }),
            'Wages_Report.xlsx'
        );

        this.setState({ openExportDialog: false });
    };

    printReport = () => {
        window.print();
        this.setState({ openExportDialog: false });
    };

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.pagename} />;
        }

        const { reportData, order, orderBy, page, rowsPerPage, totalRecords, openExportDialog, loading, error, dynamicColumns } = this.state;
        const visibleRows = stableSort(reportData, getSorting(order, orderBy));

        return (
            <React.Fragment>
              
              
                       

                        <div className="searchmaster">
                            <ul>
                            
                                <li>
                                    <p>From Date</p>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} className="inputcntlparent">
                                        <DemoContainer components={['DatePicker']} >
                                            <DatePicker className="inputcntlparent"
                                                value={this.state.fromDate} 
                                                onChange={(newValue) =>
                                                    this.setState({
                                                        fromDate: newValue,
                                                        fromDate1: dayjs(newValue).format('YYYY-MM-DD')
                                                    })
                                                }
                                                format="DD/MM/YYYY"
												disableFuture
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </li>
                                <li>
                                    <p>To Date</p>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} className="inputcntlparent">
                                        <DemoContainer components={['DatePicker']} >
                                            <DatePicker  className="inputcntlparent"
                                                value={this.state.toDate}
                                                onChange={(newValue) =>
                                                    this.setState({
                                                        toDate: newValue,
                                                        toDate1: dayjs(newValue).format('YYYY-MM-DD')
                                                    })
                                                }
                                                format="DD/MM/YYYY"
												disableFuture
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </li>
								    <li>
                                    <p>Project</p>
                                    <Autocomplete
                                        fullWidth className="inputcntlparent"
                                        options={this.state.filteredProjects}
                                        value={
                                            this.state.filteredProjects.find(
                                                (x) => x.pj_id === this.state.projectId
                                            ) || null
                                        }
                                        getOptionLabel={(option) =>
                                            option.pj_projectname || ''
                                        }
                                        onInputChange={this.searchProject}
                                        onChange={this.selectProject}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                            size="small"
                                                fullWidth
                                              
                                                placeholder="Search Project"
                                            />
                                        )}
                                    />
                                </li>
                                <li>
                                    <p>&nbsp;</p>
                                   <p> <Button variant="contained" className="exportbtn" onClick={this.handleSearch} endIcon={<SearchIcon />}>
                                        Search
                                    </Button>                                 <Button
                                        variant="contained"
                                        color="primary"
                                        className="exportbtn"
                                        onClick={this.handleOpenExportDialog}
                                    >
                                        EXPORT
                                    </Button></p>
                                </li>
                               
                            </ul>
                        </div>

                        {error && (
                            <Alert severity="error">
                                {error}
                            </Alert>
                        )}

                        {loading && (
                            <CircularProgress />
                        )}
      <Paper>
                        <TableContainer>
                            <Table id="laborreport">
                                <EnhancedTableHead
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={reportData.length}
                                    dynamicColumns={dynamicColumns}
                                />
                                <TableBody>
                                    {!this.state.projectId ? (
    <TableRow>
        <TableCell
            colSpan={2 + dynamicColumns.length + 1}
            align="center"
        >
            Please Select Project
        </TableCell>
    </TableRow>
) : totalRecords === 0 ? (
    <TableRow>
        <TableCell
            colSpan={2 + dynamicColumns.length + 1}
            align="center"
        >
            No Records Found
        </TableCell>
    </TableRow>
) : (
                                        visibleRows.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{this.formatDate(item.LabourDate)}</TableCell>
                                                <TableCell>{item.ProjectName}</TableCell>
                                                {dynamicColumns.map(col => (
                                                    <TableCell key={col} align="right">
                                                        {item[col]}
                                                    </TableCell>
                                                ))}
                                                <TableCell align="right">
                                                    Rs. {Number(item.GrandTotalAmount || 0).toLocaleString('en-IN')}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            component="div"
                            count={totalRecords}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />

                        <Dialog open={openExportDialog} onClose={this.handleCloseExportDialog}>
                            <DialogTitle>Export Labor Report</DialogTitle>
                            <DialogContent>
                                <p>Choose export format:</p>
                                <p style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        startIcon={<FileDownloadIcon />}
                                        onClick={this.exportExcel}
                                        sx={{
                                            backgroundColor: '#2e7d32',
                                            '&:hover': {
                                                backgroundColor: '#1b5e20'
                                            }
                                        }}
                                    >
                                        Excel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<PictureAsPdfIcon />}
                                        onClick={this.handleDownloadPDF}
                                        sx={{
                                            backgroundColor: '#d32f2f',
                                            '&:hover': {
                                                backgroundColor: '#b71c1c'
                                            }
                                        }}
                                    >
                                        PDF
                                    </Button>
                                </p>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleCloseExportDialog}>Cancel</Button>
                            </DialogActions>
                        </Dialog>
                    </Paper>
         
            </React.Fragment>
        );
    }
}